module.exports = __webpack_public_path__ + "static/media/1.23_preview.46f882e1.png";